import * as moment from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { SsService } from '../../shared/_services/ss.service';
import { environment } from '../../../environments/environment';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '../../shared/_services/error.service';
import { HttpClient } from '@angular/common/http';
import { DATE_FORMAT, DateModel } from '../_models/date.model';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  private date$ = new BehaviorSubject<DateModel>(null);
  private readonly SS_DATE = 'date';

  constructor(
    private errorService: ErrorService,
    private httpClient: HttpClient,
    private ssService: SsService
  ) {
    this.callGetLatestDate();
  }

  // ********************************************************************************************************
  // LOAD DATA
  // ********************************************************************************************************

  private callGetLatestDate(): void {
    const ssDate = this.ssService.getItem(this.SS_DATE);
    this.getLatestDateHttp().subscribe(
      (res) => {
        let latestDate = moment();
        if (ssDate?.date) {
          latestDate = moment(ssDate.date);
        } else if (res.data) {
          latestDate = moment(res.data).add(-1, 'days');
        }
        this.newDate(
          new DateModel({
            date: latestDate.startOf('day').format(DATE_FORMAT),
            horUpTo: ssDate?.horUpTo,
          })
        );
      },
      () => {
        this.newDate(
          new DateModel({
            date: moment().startOf('day').format(DATE_FORMAT),
            horUpTo: ssDate?.horUpTo,
          })
        );
      }
    );
  }

  private getLatestDateHttp(): Observable<any> {
    return this.httpClient
      .get(environment.urlWarp + '/last_nomination_date')
      .pipe(catchError(this.errorService.handleError));
  }

  // ********************************************************************************************************
  // BROADCAST DATA
  // ********************************************************************************************************

  newDate(newData: DateModel) {
    this.ssService.setItem(this.SS_DATE, newData);
    this.date$.next(newData);
  }

  onNewDate(): Observable<DateModel> {
    return this.date$.asObservable();
  }

  getDate(): DateModel {
    return this.date$.getValue();
  }

  getNominationDate(): DateModel {
    const curDate = this.getDate();
    return new DateModel({
      date: moment(curDate?.date).add(1, 'days').format(DATE_FORMAT),
      horUpTo: curDate?.horUpTo,
    });
  }
}
